import { initialState } from "./state"

export default {
  setContract: (state, payload) => {
    Object.keys(state.contract).forEach(key => {
      if (payload[key] !== undefined) {
        state.contract[key] = payload[key]
      }
    })
  },
  resetContract: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
